"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../00_environment/Fonts");

var _Divider = _interopRequireDefault(require("../01_atoms/Divider"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _LinkButton = _interopRequireDefault(require("../01_atoms/LinkButton"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _DefaultScreen = _interopRequireDefault(require("../02_molecules/DefaultScreen"));

var _FormContainer = _interopRequireDefault(require("../01_atoms/FormContainer"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _ResponsiveCentralPaneWrapper = _interopRequireDefault(require("../02_molecules/ResponsiveCentralPaneWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SignInOrSignUpPageUI = function SignInOrSignUpPageUI(_ref) {
  var error = _ref.error,
      email = _ref.email,
      password = _ref.password,
      _ref$onEmailChange = _ref.onEmailChange,
      onEmailChange = _ref$onEmailChange === void 0 ? function () {} : _ref$onEmailChange,
      _ref$onPasswordChange = _ref.onPasswordChange,
      onPasswordChange = _ref$onPasswordChange === void 0 ? function () {} : _ref$onPasswordChange,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$onFacebookSignIn = _ref.onFacebookSignIn,
      onFacebookSignIn = _ref$onFacebookSignIn === void 0 ? function () {} : _ref$onFacebookSignIn,
      _ref$onGoogleSignIn = _ref.onGoogleSignIn,
      onGoogleSignIn = _ref$onGoogleSignIn === void 0 ? function () {} : _ref$onGoogleSignIn,
      _ref$onAppleSignIn = _ref.onAppleSignIn,
      onAppleSignIn = _ref$onAppleSignIn === void 0 ? null : _ref$onAppleSignIn,
      title = _ref.title,
      dividerText = _ref.dividerText,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      _ref$showCreateAccoun = _ref.showCreateAccount,
      showCreateAccount = _ref$showCreateAccoun === void 0 ? true : _ref$showCreateAccoun,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('SignInOrSignUpPageUI');
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: title,
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_ResponsiveCentralPaneWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: title,
    rightButtonText: t('Back'),
    onRightButtonClick: onBack
  }, /*#__PURE__*/_react["default"].createElement(_FormContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
    onSubmit: onSubmit,
    error: !!error
  }, !!error && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    error: true,
    header: t('Error'),
    content: error
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    key: "SignInOrSignUp__email",
    name: "email",
    placeholder: t('E-mail'),
    value: email || '',
    onChange: function onChange(e, o) {
      return onEmailChange(o.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    key: "SignInOrSignUp__password",
    name: "password",
    type: "password",
    placeholder: t('Password'),
    value: password || '',
    onChange: function onChange(e, o) {
      return onPasswordChange(o.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fluid: true,
    type: "submit",
    primary: true
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginTop: 10
    }
  }, /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
    to: "/login/forgot-password/",
    style: (0, _Fonts.withWidgetSubtitleFont)({
      fontSize: '0.9rem'
    })
  }, t('Forgot your password?')))), showCreateAccount && /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
    to: "/create-account/"
  }, t('Create a free account')))))));
};

var _default = SignInOrSignUpPageUI;
exports["default"] = _default;